import { ANALYTICS_CLICK_ATTR } from '@/_constants/analytics-attrs';
import { TAnalyticEventParams } from '../../_types';

type TProps = {
  name: string;
  params?: Partial<TAnalyticEventParams>;
};

type TReturn = {
  [ANALYTICS_CLICK_ATTR]: string;
};

export const getAnalyticsClickAttr = (props: TProps): TReturn => ({
  [ANALYTICS_CLICK_ATTR]: JSON.stringify(props),
});
